module.exports = "https://de18y2hs3hlxs.cloudfront.net/55a5b72b-ea57-45f3-9ae4-45ca394141b9/images/notepad.png?75405c954d83b33e90b18b75fbe7ed89";